module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter",
    attrs: {
      "id": "chapter4"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_65"
    }
  }, [_c('em', [_vm._v("Four")])])]), _c('a', {
    attrs: {
      "id": "page_65"
    }
  }, [_c('p', {
    staticClass: "nonindent"
  }, [_vm._v("Red watched his partner’s face as they rode the elevator up to ICU. There was a muscle jerking at the side of Ben’s jaw, and his gaze was fixed. The car jolted slightly as it came to a halt, and when the doors opened, Ben English strode through them in haste. Red shook his head as he followed. Ben’s behavior was bordering on obsessive, and that made Red nervous.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But Ben didn’t care what his partner thought. What mattered most to him was catching the person responsible for the murders and making sure China Brown came to no more harm. As they neared the nurses’ station, he lengthened his stride. By the time they arrived, Red was all but running to keep up.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s a good thing we didn’t have to go any farther,” Red muttered, as they waited for the nurse on duty to finish her phone call. “I’m all out of breath.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ben glanced over at Red and grinned. “Too many chicken-fried steaks.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_65"
    }
  }, [_vm._v("Red glared. “No, I’m just too damned short. You’re what… at least a couple of inches over six feet. I’m five-seven. My legs are half as long as yours, and I ")]), _c('a', {
    attrs: {
      "id": "page_66"
    }
  }, [_vm._v("have to take two steps to your one. Chicken-fried steak, my ass.”")])]), _c('a', {
    attrs: {
      "id": "page_66"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Ben glanced down at his partner. “Not so much your ass as your belly.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Red shook his head and then chuckled. It was impossible to get ahead of this man. Before he could think of a good come-back, the nurse on duty hung up the phone.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“May I help you?” she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ben flashed his badge. “Detectives English and Fisher to see China Brown,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m sorry, but only two visitors at a time in ICU, and there’s someone with her now.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ben spun, staring intently through the glass to the ward beyond. He could just make out the figure of a man leaning over her bed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Who is he?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The nurse shook her head. “He didn’t say.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ben’s belly knotted. “That woman is the only witness to a murder. Do you let in anybody who presents themselves?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The nurse looked nervous. “I don’t have any orders to the contrary,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ben leaned over the desk, his voice hoarse with worry. “Either you go get him out of there now, or I’ll do it for you.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_66"
    }
  }, [_vm._v("She jumped up from her chair and bolted through the doors. Seconds later, she was at China’s bedside. Ben had his cell phone in hand and was making a call as the nurse began escorting the man toward the door. ")]), _c('a', {
    attrs: {
      "id": "page_67"
    }
  }, [_vm._v("By the time they reached the exit, he’d already requested a guard for China.")])]), _c('a', {
    attrs: {
      "id": "page_67"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Easy, partner,” Red said. “It’s probably the boyfriend. Remember… the one who skipped out on her. Now and then the jerks do get a guilty conscience.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But the young, thin Latino coming through the doors didn’t look like a man filled with remorse. He looked nervous.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ben stepped in front of him, blocking his way. “Detective Bennett English, Homicide. This is my partner, Detective Fisher. If you’d step this way, we’d like to ask you some questions.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The color faded from beneath the young man’s skin, leaving it a pale, ashy gray.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t know nothin’,” he said shortly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Let us be the judge of that,” Ben said, and lightly clasped his arm as they led him toward a nearby waiting room.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As soon as they were inside, they sat him down, then pulled up their chairs so they were both facing him. The implication was plain. He wasn’t going anywhere until the officers were through.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What’s your name?” Ben asked. “And how do you know China Brown?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The young Latino glared, but this time it was anger that fed his emotions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("“¿Hablo Englese?”")]), _vm._v(" Red asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The man’s gaze shifted from Ben to Red, and as it did, a look of disdain replaced his fear.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_67"
    }
  }), _c('a', {
    attrs: {
      "id": "page_68"
    }
  }, [_vm._v("“Yes, I speak English,” he said. "), _c('em', [_vm._v("“¿Habla usted español?”")])])]), _c('a', {
    attrs: {
      "id": "page_68"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Red looked a bit taken aback and then shrugged.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, then,” the man said, “looks like I’m one up on you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ben slid his foot between the young man’s outstretched legs and leaned forward. The motion of dominance was impossible to mistake.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If you two are through with your pissing contest, then I want some answers. What’s your name, and how do you know China Brown?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At that point, all the fight seemed to go out of the young man. His shoulders slumped, and he leaned forward, resting his elbows on his knees as he looked down at the floor. When he looked up, Ben was surprised to see tears in his eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Miguel. My name is Miguel Hernandez. I didn’t know her. Not really.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do you always visit people in the hospital who you don’t know?” Ben asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Look, man, it’s like this. Me and my home boys were down cruising Oakcliff the other night and this "), _c('em', [_vm._v("chica")]), _vm._v(" comes out of nowhere. Ruiz, he starts hitting on her, but I saw her belly.” He looked away, then back at Ben, almost defiant. “My sister, she’s going to have a baby. I guess I felt sorry for the woman, okay?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Oddly enough, Ben was starting to believe the man’s story. “So you played Galahad, then what?” he asked.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_68"
    }
  }, [_vm._v("Miguel frowned. “I don’t know this Galahad, and I ")]), _c('a', {
    attrs: {
      "id": "page_69"
    }
  }, [_vm._v("haven’t "), _c('em', [_vm._v("played")]), _vm._v(" since I was "), _c('em', [_vm._v("cinco")]), _vm._v("… five. I told Ruiz to get lost and then told the little mama to go home.”")])]), _c('a', {
    attrs: {
      "id": "page_69"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Ben thought of the woman in ICU. Poor China Brown. She would never be a little mama now.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Then what?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Miguel shrugged. “She said she had no home. I asked her where was the man who put the baby in her belly. She said he stole her money and ran away.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Now Ben was beginning to believe him. This coincided with the little bit they’d learned from China’s ex-landlord.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What was she doing down in that part of town?” Ben asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Looking for an all-night mission. She was cold. She was hungry. She was looking to God to protect her.” Miguel stood abruptly. His voice was hard, his expression bitter. “God. There is no God. Where was God when the little mama was in danger?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ben stood and followed Miguel to a window overlooking the parking lot.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t have any answers for you,” Ben said. “But I want some answers from you. Why are you here?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Miguel spun angrily. “Because I should have walked with her. I thought about it. It wasn’t far to the mission from where we stood. I showed her the cross on the building, then I walked away from her. If I’d gone with her, none of this would have happened and her baby would not be dead.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_69"
    }
  }, [_vm._v("Ben sighed. Guilt. The kid had come out of guilt. He ran a hand through his hair and then glanced at ")]), _c('a', {
    attrs: {
      "id": "page_70"
    }
  }, [_vm._v("Red. Red just shrugged, as if to say he was on his own. Ben turned back to Miguel.")])]), _c('a', {
    attrs: {
      "id": "page_70"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah, I suppose that could be true,” Ben said. “Or Red and I might be investigating three homicides instead of two if you’d gone.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Miguel shook his head. “Why?” he asked. “Why was she shot?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We don’t know,” Ben said. “Maybe something as simple as being in the wrong place at the wrong time.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Miguel slumped.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do you know a man by the name of Charles Finelli?” Red asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Miguel looked up. “No, I don’t know nobody by that name. Was that the name of the man who was killed?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Red nodded. “He also went by the name of Chaz.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Means nothing to me,” Miguel said, then gave both men a weary look. “Can I go now? I got places to go, man.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Got an address?” Ben asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Miguel shrugged. “Sometimes I stay with my sister.” He gave the men her name and address. “Now can I go?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah, sure,” Ben said, and handed him his card. “In case you hear anything on the streets.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Miguel frowned. “I don’t do business with the ‘man’,” he muttered, then took it and stuffed it in his coat. “Only for the little mama, you know.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah, for the little mama,” Ben said.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_70"
    }
  }), _c('a', {
    attrs: {
      "id": "page_71"
    }
  }, [_vm._v("Miguel got all the way to the doorway then stopped and turned. The look he gave Ben was dark and fierce.")])]), _c('a', {
    attrs: {
      "id": "page_71"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“You catch him, Detective. You catch the man who did this to her.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We’re doing our best,” Ben said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Miguel just shook his head and then made a hasty exit.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Red looked at Ben and shook his head. “Why do I have the feeling that our best isn’t good enough for him?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sometimes our best isn’t even good enough for me,” Ben said. “Now come on. There’s a woman I want you to meet.”")]), _vm._v(" "), _c('p', {
    staticClass: "star"
  }, [_vm._v("***")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("China was in limbo. Mercifully, her brain registered nothing of what was happening to her, and only now and then did a glimmer of cognizance surface. When it did, it came in the form of flesh-piercing pain and an inability to scream. Her body was healing, but if they’d asked her, she would have said, “Let me die.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Unaware of the countless hours of care she was receiving from the doctors and nurses, or of the persistence of one homicide detective from the Dallas P.D., she lay motionless beneath the covers, tied to machines.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_71"
    }
  }, [_vm._v("In a way, China Brown was in a chrysalis. All her life, she’d been a victim. First at the hands of her stepfather, Clyde Shubert. Then, throughout her school years, as the kid who was too quiet to speak up for herself. After that, she’d been easy pickings for a man ")]), _c('a', {
    attrs: {
      "id": "page_72"
    }
  }, [_vm._v("like Tommy Fairheart. He’d told her pretty lies for a place to live and food to eat. The fact that he’d left a part of himself behind hadn’t mattered to a man like Tommy, because he had no concept of who he was—only what it took to survive. China had been fair game for the predator that he was.")])]), _c('a', {
    attrs: {
      "id": "page_72"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Before, all the people who’d victimized her had been people she knew—men who were supposed to be taking care of her, men who were supposed to love her. Being the victim of an act of random violence became the next logical step. It remained to be seen what kind of woman would emerge.")]), _vm._v(" "), _c('p', {
    staticClass: "star"
  }, [_vm._v("***")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("The moment Ben stepped into the ICU ward, he forgot Red was behind him. He moved toward China with fixed intent, playing a game with himself that by the time he got to her bed, she would awaken. He needed to look into her eyes. She needed to know that he was there.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When he reached her bedside, he stopped, took a slow shaky breath, then leaned down until his mouth was near her ear.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I came back, just like I promised,” he said softly. “I brought a friend. His name is Red.” He straightened up and gave Red a hard stare, as if daring him to argue. “Red, say hello to Miss Brown.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Red shifted nervously. This was weird, talking to someone who didn’t even know he was there.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hello, Miss Brown. I’m real sorry you got hurt.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_72"
    }
  }, [_vm._v("Ben nodded, as if satisfied with the way Red had ")]), _c('a', {
    attrs: {
      "id": "page_73"
    }
  }, [_vm._v("played his role; he touched China’s arm, then her forehead. It was cooler than it had been before. A nurse came by on her way back to the desk.")])]), _c('a', {
    attrs: {
      "id": "page_73"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“What’s the status on China Brown?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The nurse paused. By now, all the staff knew they were cops.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She’s stable, sir.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Her condition… has it been upgraded?” Ben asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She shook her head. “Not yet. She’s still listed as critical, but she is holding her own, and that’s something to be thankful for.” Then she added, “Is there anything else?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We’re posting a guard outside ICU. No one gets in to see her unless they’re okayed by me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, sir,” she said. “I’ll make a note of that on her chart right now.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Thanks,” Ben said, and then glanced at Red. “Well?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Red looked down at the woman, then back up at Ben. “She’s sure small, isn’t she?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ben laid his hand over her fingers. “Yeah, she’s small.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Looks pretty young, too,” he added.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“According to her driver’s license, she’s twenty-six.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No next of kin, you say?” Red asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“None that we know of.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_73"
    }
  }, [_vm._v("An awkward silence enveloped the men as they ")]), _c('a', {
    attrs: {
      "id": "page_74"
    }
  }, [_vm._v("stood on either side of her bed. Finally, Red had to ask.")])]), _c('a', {
    attrs: {
      "id": "page_74"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why, Ben? Why this fascination?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ben looked up. He started to unload a big set of excuses that had to do with it being part of the job, and then something stopped him. He glanced back at China—at her pale, colorless skin—and remembered the wounds on her body and the loss she had suffered. He started to speak, but the words wouldn’t come. Then he cleared his throat and shook his head.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t know,” he said softly. “I honest to God don’t know.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Fair enough,” Red said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They stood in silence, each lost in his own set of thoughts. And then something happened.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("China drew a deep breath and then moaned. Ben jumped and reached for her face, gently cupping her cheek with the palm of his hand as he spoke.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t be afraid. I’m here.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As they watched, a single tear slipped out from beneath her eyelid and slid down the side of her face. The sight of it hit Ben like a blow to the gut. He leaned down again, his voice harsh and urgent, his own eyes blurring with empathy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You cry, girl. You cry all you want, and when you’re through and all this pain is nothing but a memory, I will find a way to make you smile. Do you hear me, China Brown? That’s a promise from me to you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Red looked away. This was starting to get to him, as well.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_74"
    }
  }), _c('a', {
    attrs: {
      "id": "page_75"
    }
  }, [_vm._v("He cleared his throat and muttered, “It’s time to go. We’ve got a killer to catch.”")])]), _c('a', {
    attrs: {
      "id": "page_75"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Ben straightened, his expression cold and angry. “And the first place we’re going is to Chaz Finelli’s apartment. Maybe there’s something there that will give us a place to start.”")]), _vm._v(" "), _c('p', {
    staticClass: "star"
  }, [_vm._v("***")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("Bobby Lee strode into the dining room and smiled at the maid who was pouring coffee into his cup.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Morning, Delia. Tell cook I’d like my eggs scrambled this morning, and bring me some biscuits and sausage gravy, too. I’m a hungry man.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, sir, Senator. Will your mother be joining you this morning?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Before Bobby Lee could answer, Mona strolled into the room and answered for herself.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m already here,” she drawled. “I’ll have fresh strawberries and toast, and bring me some of that herbal tea I like.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, ma’am,” Delia said, and hurried out of the room before the fireworks started. And they would start, of that she was certain, because, although Mona Wakefield was wearing a long, silk robe, it was obvious as all get-out that she didn’t have a stitch on under it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bobby Lee’s eyes narrowed angrily as he watched his mother take her seat. As she leaned forward to adjust the hem of her robe, the top gaped open, revealing a goodly portion of voluptuous breast. Bobby rolled his eyes heavenward.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_75"
    }
  }), _c('a', {
    attrs: {
      "id": "page_76"
    }
  }, [_vm._v("“For the Lord’s sake, Mother, tie that robe a little better or put something on under it first. Have you no shame?”")])]), _c('a', {
    attrs: {
      "id": "page_76"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Mona glanced down at herself and shrugged as she readjusted the robe.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You are such a prude, Bobby Lee. If I didn’t remember the pain of birthing you, I would swear you are not my son.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If only that were so,” he muttered beneath his breath and resumed reading the front page section of the "), _c('em', [_vm._v("Dallas Morning News")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I heard that,” Mona said. “And may I please have some of the paper?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bobby Lee took a couple of sections from the back and handed them to her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The classifieds?” she drawled.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He cursed beneath his breath and handed her another section.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Their banter was so commonplace that neither one of them took much of it to heart. Silence reigned in the dining room for all of five minutes until Delia returned with their food. A few more insults were traded between passing the butter and sugar. After that, they continued to eat while reading between bites. Mona was taking her last swallow of tea when her gaze fell on a small column of news.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, now, just listen to this, Bobby Lee.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He dropped his paper in his lap and looked up with a sigh. “Mother, you know I don’t like to be read to.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_76"
    }
  }), _c('a', {
    attrs: {
      "id": "page_77"
    }
  }, [_vm._v("She wasn’t paying him any mind, which didn’t surprise him. When had she ever?")])]), _c('a', {
    attrs: {
      "id": "page_77"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Mona cleared her throat and dabbed at her mouth with her napkin, then began to read aloud, hitting only the highlights of the story.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“‘Shooting down in Oakcliff… two killed… no witnesses… police at a loss…’”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bobby Lee interrupted. “The police are always at a loss,” he muttered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s not so,” Mona said. “You’re just mad because you got pulled over last month and ticketed for speeding.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bobby Lee’s eyes narrowed angrily. “The boy didn’t know his place.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mona grinned. “Why, I believe he did. Just because you’re a senator, that doesn’t make you God.” Her grin widened. “That comes afterward… when you’re elected president of these United States. Then you can be God.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A grudging smile centered on Bobby Lee’s handsome face. “You are a witch,” he said. “You know that, don’t you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mona arched an eyebrow. “I know nothing of the sort. Now, let me finish,” she said, and ran her finger down the page until she found her place. “Oh yes, here’s what I was trying to tell you. The man who was killed. It was Chaz Finelli.” She made a face. “I never did like that man.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_77"
    }
  }, [_vm._v("Bobby Lee’s mouth dropped. The man’s sleazeball reputation for taking scandalous photos of Dallas’s ")]), _c('a', {
    attrs: {
      "id": "page_78"
    }
  }, [_vm._v("rich and famous was well-known. The fact that his mother spoke personally of him made him nervous.")])]), _c('a', {
    attrs: {
      "id": "page_78"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“You "), _c('em', [_vm._v("know")]), _vm._v(" Finelli?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She glanced over her shoulder. “I’m all out of tea. Where’s Delia gone off to, anyway?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bobby Lee grabbed his mother by the wrist. “Mother, I asked you a question.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And I heard you,” she snapped.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("His grip tightened. “Then answer me,” he growled. “Goddamn it, I just announced my candidacy for president. I don’t need any surprises coming out of the woodwork. Exactly "), _c('em', [_vm._v("how")]), _vm._v(" do you know Chaz Finelli?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why would it matter now? He’s dead, isn’t he?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bobby Lee stood, and in that moment Mona was almost afraid of her son. His voice was shaking with fury as he loomed over her chair.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You talk to me… now!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mona shrugged. “It didn’t amount to a hill of beans,” she said. “I just got a little drunk at the mayor’s birthday party last year.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bobby Lee’s mind was racing. He remembered the incident well. He’d pulled in a lot of favors to keep it out of the press.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And…”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, hell, Bobby Lee. A woman has needs, too, you know. John Woodley and I were out in the greenhouse when a bunch of flashes went off. We thought they were part of the fireworks for the party until about a week later. John said he got some pictures in the mail.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_78"
    }
  }), _c('a', {
    attrs: {
      "id": "page_79"
    }
  }, [_vm._v("She gave Bobby Lee a nervous glance. She’d never seen him so quiet—or so angry.")])]), _c('a', {
    attrs: {
      "id": "page_79"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“What were you and John doing in those pictures?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She grinned. “Well, we weren’t counting daisies, Bobby Lee. What the hell do you think we were doing?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Jesus Christ,” he muttered. “You will be the death of me yet.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, calm down. John paid him off and got the negatives, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No blackmailer worth his salt "), _c('em', [_vm._v("ever")]), _vm._v(" gets rid of all the evidence. Somewhere, I can guarantee, there’s a copy of those pictures, and they will show up just when it matters most.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mona hated being wrong, and like her son, when faced with a problem, dealt with it in anger. She shoved her chair back with a thump and threw her napkin in his face.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How? By ghost express? He’s dead, Bobby Lee. Dead men tell no tales.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bobby Lee paled. “I’ve got to call Ainsley.” Resisting the urge to put his fist in her face, he pointed at her instead. “You don’t leave this house today, do you hear me? If you’re ever connected to his murder, then all of this is over… for both of us!”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_79"
    }
  }, [_vm._v("Bobby Lee stormed out of the dining room. Mona strode to the window overlooking the snow-covered gardens. Icicles hung from the edges of the roof like long crystal spears. A pair of cardinals darted from bush to bush in search of food—as obvious to the human ")]), _c('a', {
    attrs: {
      "id": "page_80"
    }
  }, [_vm._v("eye as blood on snow. Mona watched their futile search for food without any emotion. When they finally gave up and flew away, she abandoned the view. It was a hard world out there, and in her opinion, it didn’t matter how beautiful the birds were. If they didn’t have what it took to survive, then they didn’t deserve to live.")])]), _c('a', {
    attrs: {
      "id": "page_80"
    }
  }, [_c('p', {
    staticClass: "star"
  }, [_vm._v("***")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("A thin layer of dust covered the furnishings in Finelli’s apartment, as well as three empty pizza boxes stacked on the table with a mummified piece of pepperoni pizza lying on top. There was a small plastic bowl on the kitchen floor with a handful of dried cat food, and another bowl beside it, obviously a water dish that had long ago evaporated. One could only hope that the cat it had been meant for was long gone from the premises. Either that or the stench that they were smelling was the cat. Ben and Red were hesitant to find out.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Shoot a mile,” Red muttered. “Something sure stinks. I hope it’s not that cat. Where do you want to start?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ben pulled a pair of rubber gloves from his coat pocket and put them on.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll go in the bedroom and work my way forward. You start in the kitchen, okay?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What are we looking for?” Red asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Anything that might get a man killed.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Okay,” Red said, and then hesitated. “You got another pair of gloves? I left mine in the car.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_80"
    }
  }), _c('a', {
    attrs: {
      "id": "page_81"
    }
  }, [_vm._v("“Yeah, I think so,” Ben said, and dug through the inside pocket of his coat. “Here you go. Knock yourself out.”")])]), _c('a', {
    attrs: {
      "id": "page_81"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("With that, both men went their separate ways, looking for answers to a crime that, so far, made no sense.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Time passed as the men moved from room to room. Red refused to set foot in the bathroom, so it was Ben who got left with the job. As he walked through the doorway, the stench they’d been smelling hit him full force. After a quick search of the cabinets and drawers, he decided that it was the sink that was harboring the smell.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was streaked with grime and hair, and something that looked suspiciously like chemicals. He supposed they were the kind used in developing, but to be on the safe side, he scraped a sample off the sink. Maybe it was residue from a drug lab. If it was, manufacturing amphetamines would go a long way toward explaining why someone had wanted Finelli dead.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There was an assortment of bottles, mostly chemicals, in the cabinet beside the sink, and Ben was beginning to believe this had been Finelli’s darkroom. He moved them around, reading each one label by label, but could find nothing that looked out of place. Yet when he set one of them down, the sound seemed hollow. He shoved several bottles aside and tapped on the bottom of the shelf once more. Again the thumps seemed to echo.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hey, Red!” he yelled. “Got a minute?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Red appeared at the door.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_81"
    }
  }), _c('a', {
    attrs: {
      "id": "page_82"
    }
  }, [_vm._v("“Yeah, what’s up?”")])]), _c('a', {
    attrs: {
      "id": "page_82"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“You got your flashlight on you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Red pulled a small flashlight out of his pocket. “Like the Boy Scouts, I’m always prepared.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Grinning, Ben took it from his partner and flipped the switch. He leaned closer to the cabinet, aiming the beam of light at the cabinet floor. Almost immediately, he could tell that it had been altered from its original design. Quickly he took all the bottles out of the cabinet and set them in the sink, then took out his pocket knife and stuck the point at one end of a crack.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Whatcha got there?” Red asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t know,” Ben said. “Maybe nothing.” But he continued to dig. Within seconds, something popped, and all of a sudden the floor of the cabinet was in his hands.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Would you look at that?” Red said, and leaned closer, peering over Ben’s shoulder. “Is something in it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ben aimed the flashlight into the opening. “Son of a…”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What?” Red asked. “What’s in there?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ben began pulling out photos, along with a couple of manila envelopes, and he’d only skimmed the surface of the stash.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Red’s eyes widened. “Oh, man. Would you look at these? Hey, isn’t that Sonny Harold of the Dallas Lone Stars with the needle in his hand? I thought he was on probation.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He is,” Ben said.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_82"
    }
  }), _c('a', {
    attrs: {
      "id": "page_83"
    }
  }, [_vm._v("Red held up another. “And this one… the naked woman riding that mechanical bull. She looks familiar, but I just can’t…”")])]), _c('a', {
    attrs: {
      "id": "page_83"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“The mayor’s wife,” Ben muttered. “And I must say, I’ve seen her looking better.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Jesus!” Red said. “Where do you suppose he got these?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“With that famous little camera he was never without. You know… the one that’s missing. Without doubt, I’d say we’ve got, at the least, a good hundred or so reasons for murdering Finelli. The question remains, which one of these creeps did the deed?”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ec671d4e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/chapter4.vue
// module id = 93
// module chunks = 0